<div class="overlay" fxLayoutAlign="center center">
    <mat-progress-spinner class="spinner" [color]="color" [mode]="mode" [value]="value"></mat-progress-spinner>
</div>